var checkoutForReifen = (function ($, window) {
    "use strict";

    var $checkoutForm;
    var $radioButtons;
    var $nextButton;
    var $prevLink;
    var abTestThreeStepsOnly = true;

    var GPStatus = false;

    function initializeDOMObjects() {
        $checkoutForm = $("#checkoutForm");
        $radioButtons = $("input:radio");
        $nextButton = $("#checkoutButtonGotoNextStep");
        $prevLink = $("#checkoutButtonGotoPreviousStep");
    }

    function scrollableElement(els) {
        for (var i = 0, argLength = arguments.length; i < argLength; i++) {
            var el = arguments[i],
                $scrollElement = $(el);
            if ($scrollElement.scrollTop() > 0) {
                return el;
            } else {
                $scrollElement.scrollTop(1);
                var isScrollable = $scrollElement.scrollTop() > 0;
                $scrollElement.scrollTop(0);
                if (isScrollable) {
                    return el;
                }
            }
        }

        return [];
    }

    window.Checkout = {
        init: function initCheckout() {
            initializeDOMObjects();

            window.Checkout.setListenerForInputKeyup($checkoutForm);
            window.Checkout.setListenerForInputBlur($checkoutForm);
            window.Checkout.setListenerForRadioInputChange($checkoutForm);
            window.Checkout.setListenerForSelectChange($checkoutForm);
            window.Checkout.setLinkClickHandlers();
            window.Checkout.setListenerForValidationBeforeContinue($checkoutForm);
            window.Checkout.setListenerForSubmit($checkoutForm);
            window.Checkout.setListenerForTermsAndConditions($checkoutForm);

            window.THEME.$document.trigger("checkoutFormLoaded", [$checkoutForm]);
        },

        loadingAnimation: function loadingAnimation(reveal) {

            if (reveal === true) {

                if($("#countdown-timer").length){
                    w.Checkout.initCountdown();
                }

                $("#blend").removeClass("isHidden");
                $("#blendText").removeClass("isHidden");
            } else {
                $("#blend").addClass("isHidden");
                $("#blendText").addClass("isHidden");
            }
        },

        setListenerForRadioInputChange: function setListenerForRadioInputChange($form) {
            $form.on({
                "change": function handleCheckoutFormRadioInputChange(event) {
                    window.THEME.$document.trigger("checkoutFormRadioInputChange", [$(this)]);
                }
            }, "input[type=radio]");
        },

        setListenerForInputKeyup: function setListenerForInputKeyup($form) {
            $form.on({
                'focusout keyup change': function handleCheckoutFormInputKeyup(event) {
                    var $ccNumberInputFields = $('#CCNumberInputField1, #CCNumberInputField2, #CCNumberInputField3, #CCNumberInputField4');
                    var target = event.target;

                    if ((' ' + target.className + ' ').indexOf(' ccNumber ') > -1) {
                        window.THEME.$document.trigger('creditCardNumberInputAnyField', [$ccNumberInputFields]);
                    }
                },

                'keyup change': function handleCheckoutFormInputKeyup(event) {
                    window.THEME.$document.trigger('checkoutFormInputKeyup', [$(this)]);
                },

                'keyup': function handleCheckoutFormKeyupWithRegexp(event) {
                    var target = event.target;

                    if ((target.getAttribute('data-validation-required') === '1')
                        || (target.getAttribute('data-empty-or-validate') === '1')) {
                        window.THEME.$document.trigger('validateFormInputOnKeyup', [$(this)]);
                    }
                }
            }, "input")
        },

        setListenerForInputBlur: function setListenerForInputBlur($form) {
            $form.on({
                "focusout": function handleCheckoutFormInputBlur(event) {
                    var target = event.target;

                    if (target.disabled) {
                        return event;
                    }

                    window.THEME.$document.trigger("validateFormInputOnBlur", [$(event.target)]);
                }
            }, ":input[data-validation-required='1'], :input[data-empty-or-validate='1']");
        },

        setListenerForSubmit: function setSubmitHandler() {
            var $submitOrderButton = $("#orderSubmit").find("button[type='submit']");

            //Create a wrapper function to ensure one submission maximum
            var submitOrder = function () {
                window.Checkout.loadingAnimation(true);
                $("#checkoutForm").trigger('submit');
            };

            var oneSubmit = _.once(submitOrder);

            $submitOrderButton.on("click", function handleSubmit(event) {
                //submit without validate (nothing to validate)
                window.THEME.Utils.suppressDefaultEventFor(event);
                window.tracking.track("checkout", "logShippingTypeOnPurchase", window.Checkout.getShippingType());
                submitOrder();

                //TODO Remove as soon as we no longer need to track this info, timout shouldn't be permenant
                /*
                setTimeout(function () {
                    w.Checkout.validateFormBeforeContinue({
                        data: {
                            callbackFunction: oneSubmit
                        }
                    });
                }, 70);*/
            });
        },

        setListenerForTermsAndConditions: function ($form) {
            if(!$form.length) {
                return;
            }
            var checkbox = $("#terms-and-conditions-checkbox #acceptedTermsAndConditions");

            if(!checkbox.length) {
                return;
            }

            window.THEME.$document.trigger("checkoutAcceptTermsAndConditions", checkbox);
        },

        getShippingType: function () {
            return $(".shippingAddressTypeContainer").find("input.shippingAddressTypeSelector:checked").data("shipping-address-type");
        },

        validateFormBeforeContinue: function validateFormBeforeContinue(event) {
            var callbackIfValid;
            var $currentSubFormContainer = window.Checkout.steps.getCurrentSubFormContainer();
            var step2Valid = false;
            var validationFailed = false;

            /*
            if (! event || ! event.data) {
                callbackIfValid = window.Checkout.steps.gotoNextStep;
            } else {
                callbackIfValid = event.data.callbackFunction || window.Checkout.steps.gotoNextStep;
            }*/

            if (abTestThreeStepsOnly) {
                if (window.Checkout.steps.vars.currentStepIndex === 1) {
                    step2Valid = $("#differentRadioButton").prop("checked") === false || window.Checkout.currentFormValidates($(".j-checkout-address-other"));
                } else {
                    step2Valid = true;
                }

                if (window.Checkout.currentFormValidates($currentSubFormContainer) && step2Valid) {
                    $("#successMessageBillingAddress").addClass("isHidden");
                    //callbackIfValid();
                } else {
                    validationFailed = true;
                }
            } else {
                // DIRTY - needed for forward/backward navigation:
                if (window.Checkout.steps.vars.currentStepIndex === 2) {
                    if ($('#shipping_address_type_same_as_billing').prop('checked') === true || $('#shipping_address_type_other_address').prop('checked') === true) {
                        GPStatus = false;
                    }
                }

                if (window.Checkout.currentFormValidates($currentSubFormContainer)) {
                    $("#successMessageBillingAddress").addClass("isHidden");
                    //callbackIfValid();
                } else {
                    validationFailed = true;
                }
            }

            //TITODO simple validation for partner
            if ($('.j-service-delivery-no-partner').is(":visible")){
                validationFailed = true;
                $('.j-service-error-message').show();
            }

            if (validationFailed) {
                //prevent post if validation Failed
                event.preventDefault();
                $(scrollableElement('html', 'body'))
                    .scrollTop($(':input[data-validation-state^="invalid"]').first().offset().top - 20);
            } else {
                window.Checkout.loadingAnimation(true);
            }
        },

        currentFormValidates: function currentFormValidates($containerToValidate) {
            var $formInputs;
            var errorsCount;

            if (typeof $containerToValidate === 'object') {
                $formInputs = $containerToValidate.find('input, textarea, select').filter('[data-validation-required="1"], [data-empty-or-validate="1"]').not("[disabled]");
                $formInputs.trigger('validate-before-continue'); // This will validate all required form fields of the current checkout step
                errorsCount = $formInputs.filter('[data-validation-state^="invalid"]').length;

                return (errorsCount === 0);
            }
        },

        setListenerForValidationBeforeContinue: function setListenerForValidationBeforeContinue($form) {
            $form.on({
                'validate-before-continue': function handleCheckoutFormInputValidationBeforeContinue(event) {
                    var target = event.target;

                    if (target.disabled) {
                        return event;
                    }

                    window.THEME.$document.trigger("validateFormInputBeforeContinue", [$(event.target)]);
                }
            }, ":input[data-validation-required='1'], :input[data-empty-or-validate='1']");
        },

        setLinkClickHandlers: function setLinkClickHandlers() {
            var $togglerLink = $("#linkToggleDisplayOfAllItemsInCheckout");
            $nextButton.on("click", window.Checkout.validateFormBeforeContinue);

            $prevLink
                .off("click")
                .on("click", window.Checkout.gotoPreviousStepClickHandler);

            $togglerLink.on("click", function handleTogglerClick(event) {
                w.THEME.Utils.suppressDefaultEventFor(event);
                w.THEME.$document.trigger("oneTimeTogglerClick", [$(this)]);
            });
        },

        setListenerForSelectChange: function setListenerForSelectChange($form) {
            $form.on({
                "change": function handleCheckoutFormSelectChange() {
                    window.THEME.$document.trigger("checkoutFormSelectChange", [$(this)]);
                }
            }, "select");
        },

        steps: {
            submitOverrideFn: function submitOverrideFn() {
                w.Checkout.steps.gotoNextStep();
                return false;
            },

            init: function init() {
                this.updateLocationHash(null);
                $(window).on('hashchange', this.hashChangeHandler);
            },

            vars: {
                currentStepIndex     : 1,
                currentStepIndexStore: 1,
                visitedSteps         : [],
                dontCallNext         : false,
                dontCallPrev         : false,
                $stepSections        : $('.checkout').find('section.step'),
                count                : function countStepSections() { return w.Checkout.steps.vars.$stepSections.length; },
                slideFrom            : 1,
                slideWidth           : 960,
                slideOffset          : function slideOffset(index) {
                    var offset = 0;

                    if (!index) {
                        index = this.currentStepIndex;
                    }

                    w.Checkout.steps.vars.$stepSections.each(function calculateOffset(key) {
                        if ($(this).is(':visible') && (key + 1) < index) {
                            offset += w.Checkout.steps.vars.slideWidth;
                        }
                    });

                    return offset;
                },
                locked : false
            },

            gotoNextStep: function gotoNextStep() {
                var checkoutSteps     = w.Checkout.steps;
                var checkoutStepsVars = checkoutSteps.vars;

                if (w.Checkout.isGaragePartnerOptionSelected() && !w.Checkout.isGaragePartnerAvailable()) {
                    return;
                }

                checkoutStepsVars.locked = true;
                checkoutStepsVars.currentStepIndex += 1;
                checkoutSteps.updateLocationHash("next");

                // Dirty!!!
                // If coming from step 1 to step 2 (after having been in step 3 already), prevent eventual display of the GP tool:
                if (! abTestThreeStepsOnly) {
                    if (checkoutStepsVars.currentStepIndex === 2) {
                        GPStatus = false;
                    }
                }

                if (abTestThreeStepsOnly && checkoutStepsVars.currentStepIndex === 2) {
                    // Skip the "delivery address step" as it's part of step 1:
                    checkoutStepsVars.currentStepIndex += 1;
                    checkoutSteps.updateLocationHash("next");
                }

                if (checkoutStepsVars.currentStepIndex === 3) {
                    //A bit hacky :( - We want to remove any messages when proceeding from step 1
                    $("section.messages").remove();

                    w.Checkout.steps.actions.optimizelySegment($(".shippingAddressTypeContainer").find("input.shippingAddressTypeSelector:checked").data("shipping-address-type"));
                    w.Checkout.loadingAnimation(true);
                    w.Checkout.storeCCFieldValues();
                    w.Checkout.paymentMethods.updatePaymentMethods();
                }

                checkoutSteps.update();
                w.Checkout.steps.actions.googleAnalytics(checkoutStepsVars.currentStepIndex);
                w.Checkout.steps.actions.optimizelyGoals(checkoutStepsVars.currentStepIndex);
            },

            gotoPreviousStep: function gotoPreviousStep(numberOfSteps) {
                w.Checkout.loadPreselectedPartner();
                var i;
                numberOfSteps = numberOfSteps || 1;

                if (this.vars.currentStepIndex === 3) {
                    w.Checkout.storeCCFieldValues();
                }

                if (this.vars.currentStepIndex <= numberOfSteps || this.vars.locked) {
                    return;
                }

                this.vars.locked = true;
                this.vars.currentStepIndex -= numberOfSteps;

                for (i = numberOfSteps; i > 0; i -= 1) {
                    this.updateLocationHash('prev');
                }

                if (abTestThreeStepsOnly && this.vars.currentStepIndex === 2)  {
                    // Skip the "delivery address step" as it's part of step 1:
                    this.vars.currentStepIndex -= 1;
                    this.updateLocationHash('prev');
                }

                w.Checkout.steps.actions.googleAnalytics(this.vars.currentStepIndex);
                w.Checkout.steps.actions.optimizelyGoals(this.vars.currentStepIndex);

                this.update();
            },

            updateLocationHash: function updateLocationHash(stepDirection) {
                if (! stepDirection) {
                    // Initialize:
                    w.Checkout.steps.updateVisitedSteps(1);
                    w.Checkout.steps.IEsafeReplaceState(1);
                } else {
                    // When the location hash has been updated because 'gotoNextStep()' has been called,
                    // then the 'onhashchange' handler should be informed that it should not call
                    // 'gotoNextStep()' - same for 'gotoPreviousStep()':
                    this.vars.dontCallNext = (stepDirection === 'next');
                    this.vars.dontCallPrev = (stepDirection === 'prev');

                    if (typeof w.Checkout.steps.vars.visitedSteps[this.vars.currentStepIndex] === "undefined") {
                        w.Checkout.steps.IEsafePushState(this.vars.currentStepIndex);
                    } else {
                        w.Checkout.steps.IEsafeReplaceState(this.vars.currentStepIndex);
                    }

                    w.Checkout.steps.updateVisitedSteps(this.vars.currentStepIndex);

                }
            },

            IEsafePushState: function IEsafePushState(currentStepIndex) {
                if (typeof w.history.pushState !== "undefined") {
                    w.history.pushState({step: currentStepIndex}, "Step" + currentStepIndex, "/checkout/#" + w.Checkout.vars.stepsHashPrefix + currentStepIndex);
                } else {
                    window.location.hash = w.Checkout.vars.stepsHashPrefix + currentStepIndex;
                }
            },

            IEsafeReplaceState: function IEsafeReplaceState(currentStepIndex) {
                window.location.hash = w.Checkout.vars.stepsHashPrefix + currentStepIndex;
                if (typeof w.history.replaceState !== "undefined") {
                    w.history.replaceState({ step: currentStepIndex }, "Step" + currentStepIndex, "/checkout/#" + w.Checkout.vars.stepsHashPrefix + currentStepIndex);
                }
            },

            attachHistoryEvents: function attachHistoryEvents() {
                if (typeof window.addEventListener === "function") {
                    window.addEventListener('popstate', function popstateEventListener(event) {
                        if (event.state !== null) {
                            if (event.state.step < w.Checkout.steps.vars.currentStepIndex) {
                                w.Checkout.steps.gotoPreviousStep();
                            } else if (event.state.step > w.Checkout.steps.vars.currentStepIndex) {
                                w.Checkout.steps.gotoNextStep();
                            }
                        }
                    });
                }
            },

            updateVisitedSteps: function updateVisitedSteps(step) {
                w.Checkout.steps.vars.visitedSteps[step] = true;
            },

            hashChangeHandler: function hashChangeHandler() {
                // Reacts to the change of document.location hashes to enable
                // back-/forward navigation between the 3 different checkout steps
                var steps        = w.Checkout.steps;
                var vars         = steps.vars;
                var currentHash  = w.location.hash;
                var currentIndex = currentHash.substr((w.Checkout.vars.stepsHashPrefix.length + 1), 1);
                var indexStore   = vars.currentStepIndexStore;

                if (currentIndex && currentIndex !== indexStore) {
                    indexStore = currentIndex;

                    if (currentIndex < indexStore) {
                        if (!vars.dontCallPrev) {
                            steps.gotoPreviousStep();
                        }

                        vars.dontCallPrev = false;
                    } else if (currentIndex > indexStore) {
                        if (!steps.vars.dontCallNext) {
                            steps.gotoNextStep();
                        }

                        w.Checkout.steps.vars.dontCallNext = false;
                    }
                }
            },

            goBack: function goBack(step) {
                this.vars.currentStepIndex = step + 1;
                this.gotoPreviousStep();
            },

            ensureVisibility: function ensureVisibility(el) {
                if (el.offset().top - w.THEME.$document.scrollTop() < 0) {
                    $("html, body").animate({ scrollTop: Math.floor(el.offset().top - 8) }, 800);
                }
            },

            update: function update() {
                var $checkoutStepsContainer = $("#checkoutStepsContainer");
                var $checkoutLinkBackToCart = $("#checkoutLinkBackToCart");
                var $buttonGotoPreviousStep = $("#checkoutButtonGotoPreviousStep");
                var checkoutSteps    = w.Checkout.steps;
                var stepsVars        = checkoutSteps.vars;
                var currentStepIndex = stepsVars.currentStepIndex;

                switch (currentStepIndex) {
                    case 1:
                        w.Checkout.steps.showLastStep(false);
                        $backToBasketLink.removeClass("isHidden");
                        $prevLink.addClass("isHidden");
                        break;

                    case 2:
                        w.Checkout.steps.showLastStep(false);

                        w.Checkout.copyBillingAddressTo($("#billingAddressReminder"));
                        $backToBasketLink.addClass("isHidden");
                        $prevLink
                            .html($prevLink.data("html-step" + currentStepIndex))
                            .removeClass("isHidden");
                        break;

                    case 3:
                        w.Checkout.steps.showLastStep(false);
                        $nextButton.addClass("isHidden");
                        $backToBasketLink.addClass("isHidden");
                        break;

                    case 4:
                        w.Checkout.steps.showLastStep(true);
                        $nextButton.addClass("isHidden");
                        w.Checkout.fillOptionsSummary();
                        w.Checkout.updateOrderSubmitButtonLabel();

                        // Ugly hack to remove footnote text from step4 in French checkout
                        if (window.THEME.country === "fr") {
                            $(".checkoutFooter .footnoteText").addClass("isHidden");
                        }
                        break;
                }

                $checkoutStepsContainer
                    .removeClass("step1 step2 step3 step4")
                    .addClass("step" + currentStepIndex);

                if (currentStepIndex < 5) {
                    w.Checkout.progressIndicator.activate(currentStepIndex);
                }

                if (abTestThreeStepsOnly) {
                    if (currentStepIndex < 4) {
                        w.Checkout.prevNextLinks.updateLinks(currentStepIndex);
                    }
                } else {
                    if (currentStepIndex < 5) {
                        w.Checkout.prevNextLinks.updateLinks(currentStepIndex);
                    }
                }

                if (currentStepIndex === 3) {
                    // Erik wants this for step 3:
                    $checkoutFormFooterActions.css("float", "left");
                } else {
                    $checkoutFormFooterActions.css("float", "right");
                }

                // GP tool hackery - SHAME!
                if (
                    abTestThreeStepsOnly === true && currentStepIndex === 1 ||
                    abTestThreeStepsOnly === false && currentStepIndex === 2
                ) {
                    if (GPStatus) {
                        displayGPTool(GPStatus);
                    }
                }

                if (currentStepIndex > 3) {
                    GPStatus = false;
                }

                stepsVars.locked = false;
            },

            showLastStep: function showLastStep(unhide) {
                var $mainContentFoundationRow        = $("#mainContentFoundationRow");
                var $checkoutOptionsContainer        = $("#checkoutOptionsContainer");
                var $checkoutOrderOverviewContainer  = $("#checkoutOrderOverviewContainer");
                var $checkoutOptionsSummaryContainer = $("#checkoutOptionsSummaryContainer");
                var $checkoutLastStepContainer       = $("#checkoutLastStepContainer");
                var $checkoutFormFooter              = $("#checkoutFormFooter");

                if (unhide) {
                    $mainContentFoundationRow.addClass("lastStep"); // This will change the background image through CSS
                    $checkoutOptionsContainer.addClass("isHidden");
                    $checkoutOrderOverviewContainer.addClass("isHidden");
                    $checkoutFormFooter.addClass("isHidden");
                    $checkoutOptionsSummaryContainer.removeClass("isHidden");
                    $checkoutLastStepContainer.removeClass("isHidden");
                } else {
                    $mainContentFoundationRow.removeClass("lastStep"); // This will change the background image through CSS
                    $checkoutOptionsContainer.removeClass("isHidden");
                    $checkoutOrderOverviewContainer.removeClass("isHidden");
                    $checkoutFormFooter.removeClass("isHidden");
                    $checkoutOptionsSummaryContainer.addClass("isHidden");
                    $checkoutLastStepContainer.addClass("isHidden");
                }
            },

            updateOffset: function updateOffset(index) {
                $('#checkoutSteps').css({ marginLeft: -this.vars.slideOffset(index) });
            },

            actions: {
                encode: function encode(string) {
                    return $("<div/>").text(string ? string : "").html();
                },

                optimizelySegment: function optimizelySegment(segment) {
                    if (w.Checkout.isTrackableUser()) {
                        if ("optimizely" in window) {
                            window.optimizely.push(['addToSegment', 'shippingMethod', segment]);
                        }
                    }
                },

                optimizelyGoals: function optimizelyGoals(step) {
                    if (w.Checkout.isTrackableUser()) {
                        var optimizelyUrl = this.getOtimizelyUrl(step);

                        if ("optimizely" in window) {
                            window.optimizely.push(['trackEvent', optimizelyUrl]);
                        }
                    }
                },

                getOtimizelyUrl: function getOtimizelyUrl(step) {

                    if (abTestThreeStepsOnly) {
                        switch (step) {
                            case 1:
                                return 'checkoutPersonalAddress';

                            case 3:
                                return 'checkoutPayment';

                            case 4:
                                return 'checkoutConfirm';
                        }
                    }
                    else {
                        switch (step) {
                            case 1:
                                return 'checkoutPersonalDetails';
                            case 2:
                                return 'checkoutAddress';
                            case 3:
                                return 'checkoutPayment';

                            case 4:
                                return 'checkoutConfirm';
                        }
                    }
                },

                googleAnalytics: function googleAnalytics(step) {
                    if (w.Checkout.isTrackableUser()) {
                        var trackingUrl = this.googleAnalyticsUrls(step);

                        w.tracking.track("checkout", "logPageView", trackingUrl);
                    }
                },

                googleAnalyticsUrls: function googleAnalyticsUrls(step) {
                    switch (step) {
                        case 1:
                            return '/checkout/';

                        case 3:
                            return '/checkout/payment';

                        case 4:
                            return '/checkout/confirm';
                    }
                }
            },

            getCurrentSubFormContainer: function stepsGetCurrentSubFormContainer() {
                var $container = $("#checkoutForm .form-inline.personal-data");

                if (window.Checkout.steps.vars.currentStepIndex === 2) { // DeliveryAddress
                    window.$container = $container;
                    $container = $container
                        .find(".shippingAddressTypeSelector:checked")
                        .closest(".shippingAddressTypeContainer");
                } else if (window.Checkout.steps.vars.currentStepIndex === 3) { // PaymentMethods
                    window.$container = $container;
                    $container = $container
                        .find(".paymentMethodSelector:checked")
                        .closest(".paymentMethodContainer");
                }

                return $container;
            },

            getCurrentStepName: function stepsGetCurrentStepName() {
                var currentStepName;
                var currentViewName = "undefined";

                if (abTestThreeStepsOnly) {
                    switch (wwindow.Checkout.steps.vars.currentStepIndex) {
                        case 1:
                            currentViewName = "billing_address";
                            if (! window.Checkout.isGaragePartnerOptionSelected() || ! window.Checkout.isGaragePartnerAvailable()) {
                                currentStepName = "shippingAddressNoGPAvailable";
                            } else if (chosenGaragePartner === false) {
                                currentStepName = "shippingAddressNoGPChosen";
                            } else if (chosenGaragePartner.onlineBooking === false) {
                                currentStepName = "shippingAddressGPChosenNoAppointmentAvailable";

                                if ($('#GPToolContainer').is(':visible')) {
                                    currentViewName = "garagepartner_detail";
                                }
                            } else if (chosenGaragePartner.hasReservation === true) {
                                currentStepName = "shippingAddressGPChosenNoAppointmentAvailable";

                                if ($('#GPToolContainer').is(':visible')) {
                                    currentViewName = "garagepartner_booking";
                                }
                            } else {
                                currentStepName = "shippingAddressGPChosenNoAppointmentChosen";

                                if ($('#GPToolContainer').is(':visible')) {
                                    currentViewName = "garagepartner_booking";
                                }
                            }
                            break;
                        case 3:
                            currentViewName = "paymentMethod";
                            break;
                        case 4:
                            currentViewName = "orderSummary";
                            break;
                        case 5:
                            currentViewName = "orderConfirmation";
                            break;
                    }
                } else {
                    switch (window.Checkout.steps.vars.currentStepIndex) {
                        case 1:
                            currentStepName = "billingAddress";
                            currentViewName = "billing_address";
                            break;
                        case 2:
                            currentViewName = "shipping_address";

                            if (! window.Checkout.isGaragePartnerOptionSelected() || ! window.Checkout.isGaragePartnerAvailable()) {
                                currentStepName = "shippingAddressNoGPAvailable";
                            } else if (chosenGaragePartner === false) {
                                currentStepName = "shippingAddressNoGPChosen";
                            } else if (chosenGaragePartner.onlineBooking === false) {
                                currentStepName = "shippingAddressGPChosenNoAppointmentAvailable";

                                if ($('#GPToolContainer').is(':visible')) {
                                    currentViewName = "garagepartner_detail";
                                }
                            } else if (chosenGaragePartner.hasReservation === true) {
                                currentStepName = "shippingAddressGPChosenNoAppointmentAvailable";

                                if ($('#GPToolContainer').is(':visible')) {
                                    currentViewName = "garagepartner_booking";
                                }
                            } else {
                                currentStepName = "shippingAddressGPChosenNoAppointmentChosen";

                                if ($('#GPToolContainer').is(':visible')) {
                                    currentViewName = "garagepartner_booking";
                                }
                            }

                            break;
                        case 3:
                            currentViewName = "payment_method";
                            break;
                        case 4:
                            currentViewName = "order_summary";
                            break;
                        case 5:
                            currentViewName = "order_confirmation";
                            break;
                    }
                }

                setCurrentNavigationView(currentViewName);

                return currentStepName;
            }
        },
    };

    $(document).ready(function () {
        window.Checkout.init();
    });

}(window.jQuery, window));
